export class ManikEntityFE {
  constructor() {}
  public minDate = new Date();
  public defaultStartDate = new Date();
  public defaultEndDate = new Date();
  public EndPoint = "https://entityserver.manikworks.com/";
  public PreSubmit(event: any): void {
    event.target.classList.add("manik-loader");
    let inputs: any = document.getElementsByTagName("INPUT");
    for (var i in inputs) {
      if (
        inputs[i].type == "button" ||
        inputs[i].type == "submit" ||
        inputs[i].type == "text" ||
        inputs[i].type == "email" ||
        inputs[i].type == "password" ||
        inputs[i].type == "checkbox"
      )
        inputs[i].disabled = true;
    }
  }

  public PostSubmit(event: any, enableAll: boolean = true): void {
    event.target.classList.remove("manik-loader");
    event.srcElement.removeAttribute("disabled");

    let inputs: any = document.getElementsByTagName("INPUT");
    for (var i in inputs) {
      if (enableAll) {
        if (
          inputs[i].type == "button" ||
          inputs[i].type == "submit" ||
          inputs[i].type == "text" ||
          inputs[i].type == "email" ||
          inputs[i].type == "password" ||
          inputs[i].type == "checkbox"
        )
          inputs[i].disabled = false;
      }
    }
  }

  public manikInteger(event: any) {
    let regexStr = "^[0-9]*$";
    let e = <KeyboardEvent>event;
    if (
      [8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 39 && (e.ctrlKey || e.metaKey))
    ) {
      return;
    }
    let ch = String.fromCharCode(e.keyCode);
    let regEx = new RegExp(regexStr);
    if (regEx.test(ch)) return;
    else e.preventDefault();
  }

  public manikDecimal(event: any) {
    let regexStr = "^[0-9]*$";
    let e = <KeyboardEvent>event;
    if (
      [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 39 && (e.ctrlKey || e.metaKey))
    ) {
      return;
    }
    let ch = String.fromCharCode(e.keyCode);
    let regEx = new RegExp(regexStr);
    if (regEx.test(ch)) return;
    else e.preventDefault();
  }

  public copyToClipboard(val: string) {
    let selBox = document.createElement("textarea");
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  public getManikDateString(date: any): string {
    let newDate: Date = new Date(date);
    return (
      newDate.getMonth() +
      1 +
      "-" +
      newDate.getDate() +
      "-" +
      newDate.getFullYear()
    );
  }

  public getValidUrl(url: string): string {
    if (!url) {
      return "";
    }
    if (url.includes("http://")) {
      return url;
    } else {
      return "http://" + url;
    }
  }

  public BindJS(jsUrl): void {
    let el1 = document.createElement("script");
    el1.setAttribute("src", jsUrl);
    document.body.appendChild(el1);
  }

  // public BindCSS(e: any, t: any = null, n: any = null) {
  //   var i = window.document.createElement("link");
  //   var o = t || window.document.getElementsByTagName("script")[0];
  //   i.rel = "stylesheet";
  //   i.href = e;
  //   i.media = "only x";
  //   o.parentNode.insertBefore(i, o);
  //   setTimeout(function () { i.media = n || "all" });
  // }

  public BindCSS(url: string) {
    var body = document.body;
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    body.appendChild(link);
  }
}

export class CookieManager {
  public static getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(";");
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, "");
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return "";
  }

  public static deleteCookie(name: string) {
    this.setCookie(name, "", -1);
  }

  public static setCookie(
    name: string,
    value: string,
    expireDays: number,
    path: string = ""
  ) {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : "";
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }
}
